export const getters = {
  schedulingtype: state => state.schedulingtype,
  schedulingtypes: state => state.schedulingtypes
}

const GET_SCHEDULINGTYPE = 'schedulingtype/schedulingtype'
const GET_SCHEDULINGTYPES = 'schedulingtype/schedulingtypes'

export const gettersTypes = {
  GET_SCHEDULINGTYPE,
  GET_SCHEDULINGTYPES
}
export default getters



// WEBPACK FOOTER //
// ./src/store/module/schedulingtype/getters.js